/* ============================================================
   LiquorVerse Cocktail Creator (cocktail-creator-v1).
   ===== LIBRARY = SHOPIFY cocktail metaobjects [2026-10-28] =====
   Reads the cocktail library the section renders from Shopify
   (`cocktail` metaobjects with creator_* fields) and matches it in the
   browser against the visitor's shelf, mixers and flavor moods. No
   server and no external data: adding a cocktail in Shopify adds it here.
   ============================================================ */
(function () {
  'use strict';

  /* The cocktail library comes from Shopify [2026-10-28]: the section renders every
     ACTIVE `cocktail` metaobject with creator_* fields into
     <script type="application/json" data-lv-cocktail-lib> (see the section header).
     Each entry: {name, url, cat, season, desc, spirits[], mixers[], flavors[],
     extras[{key, name, variant_id?, price_cents?, url?}]}. */
  /* Shelf words + labels come from snippets/lv-creator-vocab (generated from the import
     skill's creator_vocab.py): {kitchen:{key:label}, base:{key:label}, extra:{key:label},
     shelf:[[keyword,key]…] longest first}. */
  var VOCAB = { kitchen: {}, base: {}, extra: {}, shelf: [] };

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function init(root) {
    var LIB = [];
    var vocTag = root.querySelector('[data-lv-creator-vocab]');
    try { VOCAB = JSON.parse(vocTag ? vocTag.textContent : '{}') || VOCAB; } catch (e1) { /* keep empty vocab */ }
    VOCAB.shelf = VOCAB.shelf || [];
    function label(map, k) { return (VOCAB[map] && VOCAB[map][k]) || k; }
    var libTag = root.querySelector('[data-lv-cocktail-lib]');
    try { LIB = JSON.parse(libTag ? libTag.textContent : '[]') || []; } catch (e0) { LIB = []; }
    var shelf = root.querySelector('[data-lv-shelf]');
    var mixers = root.querySelector('[data-lv-mixers]');
    var flavors = root.querySelector('[data-lv-flavors]');
    var readyGrid = root.querySelector('[data-lv-ready-grid]');
    var awayGrid = root.querySelector('[data-lv-away-grid]');
    var readyWrap = root.querySelector('[data-lv-ready-wrap]');
    var awayWrap = root.querySelector('[data-lv-away-wrap]');
    var counts = root.querySelector('[data-lv-res-count]');
    var empty = root.querySelector('[data-lv-cr2-empty]');
    if (!shelf || !mixers || !readyGrid) return;

    function getShelf() {
      var s = [];
      shelf.querySelectorAll('.lv-bottle-chip:not(.off)').forEach(function (c) {
        if (c.dataset.spirit) s.push(c.dataset.spirit);
      });
      return s;
    }
    function getMixers() {
      var m = [];
      mixers.querySelectorAll('input:checked').forEach(function (i) { m.push(i.value); });
      return m;
    }
    function getFlavors() {
      var f = [];
      if (flavors) flavors.querySelectorAll('.lv-fl.on').forEach(function (b) { f.push(b.dataset.f); });
      return f;
    }

    function recipeUrl(c) {
      if (c.url) return c.url;
      return '/pages/' + c.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }

    function card(c, away) {
      var fl = getFlavors().filter(function (f) { return (c.flavors || []).indexOf(f) >= 0; });
      var html = '<article class="lv-c-card' + (away ? ' away' : '') + '">' +
        '<div class="lv-c-tags"><span class="lv-ct">' + esc(c.cat) + '</span>' +
        (c.season ? '<span class="lv-ct season">' + esc(c.season) + '</span>' : '') +
        (fl.length ? '<span class="lv-ct">' + fl.join(' · ') + '</span>' : '') + '</div>' +
        '<h3>' + esc(c.name) + '</h3>' +
        '<div class="lv-c-uses">Uses: <b>' + (c.spirits || []).map(function (k) { return esc(label('base', k)); }).join(' or ') + '</b>' +
          ((c.extras || []).length ? ' + ' + c.extras.map(function (x) { return esc(x.name); }).join(', ') : '') +
          (c.mixers && c.mixers.length ? ' + ' + c.mixers.map(function (k) { return esc(label('kitchen', k).toLowerCase()); }).join(', ') : '') + '</div>' +
        '<p class="lv-c-desc">' + esc(c.desc) + '</p>';
      if (away && c.needs) {
        /* With a product handle: a "View bottle" link that resolve() swaps for Add to cart
           once /products/<handle>.js says it's available. No handle: search. */
        var action = c.needs.product
          ? '<a class="lv-miss-atc" data-lv-resolve="' + esc([c.needs.product].concat(c.needs.alts || []).join(' ')) + '" href="/products/' + encodeURIComponent(c.needs.product) + '">View bottle →</a>'
          : '<a class="lv-miss-atc" href="/search?q=' + encodeURIComponent(c.needs.name) + '">Find it →</a>';
        html += '<div class="lv-missing"><div class="lv-miss-label">One bottle away</div>' +
          '<div class="lv-miss-row"><b>' + esc(c.needs.name) + '</b>' + action + '</div></div>';
      }
      html += '<div class="lv-c-actions"><a class="lv-c-link" href="' + esc(recipeUrl(c)) + '">Full recipe →</a></div></article>';
      return html;
    }

    function rank(list, f) {
      return list.slice().sort(function (a, b) {
        var af = (a.flavors || []).filter(function (x) { return f.indexOf(x) >= 0; }).length;
        var bf = (b.flavors || []).filter(function (x) { return f.indexOf(x) >= 0; }).length;
        return bf - af;
      });
    }

    /* Ready = a base spirit on the shelf + every mixer checked + every extra bottle on
       the shelf. One bottle away = the same, with exactly ONE extra bottle missing
       (that bottle becomes the card's Add to cart). Two or more missing = not shown. */
    function match(s, m, f) {
      var ready = [], away = [];
      LIB.forEach(function (c) {
        var extras = c.extras || [];
        var missing = extras.filter(function (x) { return s.indexOf(x.key) < 0; });
        /* A drink with no base spirit (spritzes, Kir Royale) needs at least one of its
           bottles on the shelf, or every one of them would show on an empty shelf. */
        var hasSpirit = (c.spirits || []).length
          ? (c.spirits || []).some(function (sp) { return s.indexOf(sp) >= 0; })
          : missing.length < extras.length;
        var hasMixers = (c.mixers || []).every(function (mx) { return m.indexOf(mx) >= 0; });
        if (!hasSpirit || !hasMixers) return;
        if (missing.length === 0) ready.push(c);
        else if (missing.length === 1) away.push(Object.assign({}, c, { needs: missing[0] }));
      });
      return Promise.resolve({ ready: rank(ready, f), away: rank(away, f) });
    }

    function render() {
      var s = getShelf(), m = getMixers(), f = getFlavors();
      match(s, m, f).then(function (data) {
        var ready = data.ready || [], away = data.away || [];
        readyGrid.innerHTML = ready.map(function (c) { return card(c, false); }).join('');
        if (awayGrid) awayGrid.innerHTML = away.map(function (c) { return card(c, true); }).join('');
        if (readyWrap) readyWrap.hidden = ready.length === 0;
        if (awayWrap) awayWrap.hidden = away.length === 0;
        if (empty) empty.hidden = ready.length > 0 || away.length > 0;
        if (counts) counts.textContent = ready.length + ' ready · ' + away.length + ' one bottle away';
        resolve();
      }).catch(function () {
        if (empty) {
          empty.hidden = false;
          empty.textContent = 'The Creator is mid-shake — try again in a moment.';
        }
      });
    }

    /* "One bottle away" Add to cart: look the bottle up only when its card is shown.
       Cached per handle; sold out / not found keeps the "View bottle" link. */
    var PRODUCTS = {};
    function lookup(handle) {
      if (!PRODUCTS[handle]) {
        PRODUCTS[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }
      return PRODUCTS[handle];
    }
    function resolve() {
      root.querySelectorAll('[data-lv-resolve]').forEach(function (a) {
        /* Handles in preference order (the drink's picks, then the store default):
           the first one in stock becomes the Add to cart. */
        var handles = a.getAttribute('data-lv-resolve').split(' ').filter(Boolean);
        a.removeAttribute('data-lv-resolve');
        (function next(i) {
          if (i >= handles.length) return;
          lookup(handles[i]).then(function (p) {
            var v = p && p.available && p.variants ? p.variants.filter(function (x) { return x.available; })[0] : null;
            if (!v) { next(i + 1); return; }
            if (!a.isConnected) return;
            a.href = '/products/' + encodeURIComponent(handles[i]);
          var b = document.createElement('button');
          b.className = 'lv-miss-atc';
          b.type = 'button';
          b.setAttribute('data-lv-add-id', String(v.id));
          b.textContent = 'Add to cart — ' + (window.LV && window.LV.fmtUSD ? window.LV.fmtUSD(v.price) : '$' + (v.price / 100).toFixed(2));
          a.replaceWith(b);
          });
        })(0);
      });
    }

    /* shelf chip toggle + manual add */
    shelf.addEventListener('click', function (e) {
      var chip = e.target.closest('.lv-bottle-chip');
      if (chip) {
        chip.classList.toggle('off');
        render();
      }
    });
    var addInput = root.querySelector('[data-lv-add-input]');
    var addBtn = root.querySelector('[data-lv-add-btn]');
    function addBottle() {
      var val = (addInput.value || '').trim().toLowerCase();
      if (!val) return;
      var spirit = null;
      var padded = ' ' + val.replace(/['’]/g, '').replace(/[-,.()\/]/g, ' ').replace(/&/g, ' and ') + ' ';
      VOCAB.shelf.forEach(function (k) {
        var kw = ' ' + String(k[0]).replace(/['’]/g, '').replace(/-/g, ' ').replace(/&/g, ' and ') + ' ';
        if (!spirit && padded.indexOf(kw) !== -1) spirit = k[1];
      });
      var chip = document.createElement('span');
      chip.className = 'lv-bottle-chip';
      chip.dataset.spirit = spirit || val;
      chip.innerHTML = esc(addInput.value.trim()) + '<span class="lv-chip-x">✕</span>';
      shelf.appendChild(chip);
      addInput.value = '';
      render();
    }
    if (addBtn) addBtn.addEventListener('click', addBottle);
    if (addInput) addInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') addBottle(); });

    mixers.addEventListener('change', render);
    if (flavors) flavors.addEventListener('click', function (e) {
      var fl = e.target.closest('.lv-fl');
      if (fl) {
        fl.classList.toggle('on');
        render();
      }
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-lv-cocktail-creator]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
